
import {ElLoading} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件名称",
        width: 164,
    },
    {
        prop: "mountings_specification",
        label: "规格",
        width: 75,
    },
    {
        prop: "mountings_encoding",
        label: "编码",
        width: 75,
    },
    {
        prop: "mountings_type_p_name",
        label: "大类",
        width: 75,
    },
    {
        prop: "mountings_type_name",
        label: "小类",
        width: 75,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 75,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 75,
    },
    {
        prop: "mountings_selling_price",
        label: "销售价",
        width: 75,
    },
    {
        prop: "ctock_price",
        label: "库存单价",
        width: 75,
    },
    {
        prop: "mountings_stock",
        label: "库存",
        width: 75,
    },
    {
        prop: "mountings_price",
        label: "金额",
        width: 75,
    },
    {
        prop: "stock_warning",
        label: "预警",
        width: 75,
    }
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, pickingInfoExport, partsStockExport, updateWarning, getSupplierTotalList,
} from "@/api/http";


import {Request} from '@/api/request';
import {validateInput, validateClass} from "@/assets/js/formRules";
import {partsFormType} from "@/assets/types/common";
import {useRoute, useRouter} from 'vue-router'

export default defineComponent({
    name: "partsStockList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['配件库存']);
        
        const headClass = inject("headClass");
        //增加取消启用预警按钮，禁用按钮
        let cancelWarnClick = ((id:number)=>{
                updateWarning({id}).then((res:any)=>{
                    if (res.status==202){
                        getTableData();
                    }
                });
            }),
            disableClick = ((item:any)=>{
                getSetManagement({
                    id: item.mountings_id,
                    status: item.status == 1 ? 0 : 1,
                }).then((res) => getTableData());
            });
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            totalData = reactive({
                total_price:'',
                total_stock:0
            }),
            supplierList = ref([] as Array<parts>),
            total = ref(0),
            loading = ref(true),
            type = ref(''),
            route: any = useRoute(),
            Router: any = useRouter(),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search: ''
            }),
            selectList = ref({
                classificationa: [],
                classificationb: [],
                MountingsBrand: []
            }),
            remote_loading = ref(false),
            screenParameter = ref({
                status: null,
                search: '',
                page: currentPage.value,
                pagesize: pageSize.value,
                mountings_type_pid: null,
                mountings_type_id: null,
                branch_id: null,
                supplier_id:null
            } as any),
            dialog_model = ref(''),
            dialogTitle = ref("新增配件"),
            formRef = ref(null),
            form = ref({
                mountings_name: '',
                mountings_id: '',
                mountings_stock: ''
            } as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                cost_price: [{required: true, message: '必填', trigger: "change"}],
                mountings_type_pid: [{required: true, message: '必填', trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            getsupplierList = (): void => {
                getSupplierTotalList({status:1}).then((res: any) => {
                    supplierList.value = res?.content?.list || [];
                })
            },
            getTableData = (): void => {
                loading.value = true;
                console.log(currentPage.value)
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/partsStockList',
                    data: {
                        ...screenParameter.value,
                        page: currentPage.value,
                        pagesize: pageSize.value
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    totalData.total_price = res?.content?.total_price;
                    totalData.total_stock = res?.content?.total_stock;
                })
                
            },
            //合计
            getSummaries = (param:any) => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "mountings_stock",
                    "mountings_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "mountings_stock") {
                            sums[index] = totalData.total_stock;
                        } else if (column.property == "mountings_price") {
                            sums[index] = totalData.total_price;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                
                partsStockExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(() => {
                    loading.close();
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                // screenParameter[key] = e;
                if (key == 'mountings_type_pid') {
                    screenParameter.value.mountings_type_id = null
                    Request.axiosInstance({
                        url: 'adminapi/MountingsType/totalList',
                        data: {pid: screenParameter.value.mountings_type_pid}
                    }).then((res: any) => {
                        selectList.value.classificationb = res?.content?.list
                    })
                    return
                }
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({search: e});
            },
            formSelectChange = (e: number) => {
                getSelectData({type_pid: e});
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    let data: any = {...form.value, id: 0};
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({type_pid: form.value.mountings_type_pid});
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            _submitForm = (): void => {
                
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/partsStockUpWarning',
                    data: form.value
                }).then((res: any) => {
                    if (res.status != 202) return
                    dialog_model.value = ''
                    getTableData()
                })
            },
            setRowClass = (row:any,column:any,rowIndex:number,columnIndex:number ):string=>{
                // console.log('222',row);
                if (row.row.mountings_stock<=row.row.stock_warning && row.row.is_warning==1){
                    return 'text-red';
                }
                return "";
            },
            
            _option = (url: string, data: any) => {
                Router.push({
                    path: url,
                    query: data
                })
            },
            _purchaseMarkin = (id: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/purchaseMarkin',
                    data: {purchase_id: id}
                }).then((res: any) => {
                    getTableData()
                })
            }
        onMounted(() => {
            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/MountingsType/totalList',
                    data: {}
                }),
                Request.axiosInstance({
                    url: 'adminapi/MountingsBrand/list',
                    data: {status: 1}
                })
            ]).then((res: any) => {
                selectList.value.classificationa = res[0]?.content?.list
                selectList.value.MountingsBrand = res[1]?.content?.list
            })
            getTableData();
            getsupplierList();
            
        });
        
        watch(dialog_model, (newval: any, oldval: any) => {
            if (newval == 'warning') {
                form.value.mountings_stock = ''
                
                console.log(form.value)
            }
            
        })
        
        
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            selectList,
            remote_loading,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            _submitForm,
            type,
            _option,
            _purchaseMarkin,
            screenParameter,
            dialog_model,
            exportChange,
            getSummaries,
            totalData,
            cancelWarnClick,
            disableClick,
            setRowClass,
            supplierList
        };
    },
});
